import React, { useState } from "react";
import { Grid, Typography, Button } from "@mui/material";
import { Divider } from "@mui/material";
import LabelButton from "../../components/reusable-components/buttons/LabelButton";
import CustomRegisterForm from "./CustomRegisterForm";

export default function CustomRegisterInvitePage({
  user,
  inviteToken,
  handleGoogleRegister,
}) {
  const [continueWithEmail, setContinueWithEmail] = useState(false);

  const handleRegisterWithEmail = () => {
    setContinueWithEmail(true);
  };

  return continueWithEmail || user?.authInfo ? (
    <CustomRegisterForm
      user={user}
      inviteToken={inviteToken}
    />
  ) : (
    <>
      {/* pre filled school name and user email */}
      <Grid
        item
        sx={{
          width: "100%",
          height: "60px",
          padding: "12px 20px",
          border: "1px solid var(--Neutrals-500, #E2E6E9)",
          borderRadius: "10px",
          marginBottom: "34px",
        }}>
        <Grid
          container
          direction="column"
          sx={{
            height: "100%",
            width: "100%",
            justifyContent: "space-between",
          }}>
          <Typography
            sx={{
              color: "var(--Primary-900, #0B0926)",
              fontFamily: "Lato",
              fontSize: 14,
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "normal",
            }}>
            {user?.accountName}
          </Typography>
          <Typography
            sx={{
              color: "var(--Neutrals-900, #6F8090)",
              fontFamily: "Lato",
              fontSize: 10,
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "normal",
            }}>
            {user?.email}
          </Typography>
        </Grid>
      </Grid>
      {/* google button */}
      <Grid
        item
        sx={{
          width: "100%",
          height: "auto",
        }}>
        <Grid
          container
          direction="column"
          sx={{
            width: "100%",
            height: "100%",
            justifyContent: "space-between",
          }}>
          <Grid
            item
            sx={{ width: "100%", height: "60px" }}
            className="start-with-google">
            <Button
              color="primary"
              fullWidth
              onClick={handleGoogleRegister}
              sx={{
                border: "2px solid #16124C",
                borderRadius: "6px",
                height: "100%",
              }}>
              <>
                <img
                  src="https://lh3.googleusercontent.com/COxitqgJr1sJnIDe8-jiKhxDx1FrYbtRHKJ9z_hELisAlapwE9LUPh6fcXIfb5vwpbMl4xl9H9TRFPc5NOO8Sb3VSgIBrfRYvW6cUA"
                  alt="google"
                  style={{
                    height: "24px",
                    marginRight: "10px",
                  }}
                />
                <Typography
                  sx={{
                    color: "var(--Primary-500, #16124C)",
                    fontFamily: "Lato",
                    fontSize: 14,
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "normal",
                    textTransform: "none",
                  }}>
                  Continue with Google
                </Typography>
              </>
            </Button>
          </Grid>
        </Grid>
      </Grid>
      {/* devider and email button */}
      {!user?.isCPSEmail && (
        <>
          <Divider
            sx={{
              width: "100%",
              color: "var(--Neutrals-900, #6F8090)",
              fontFamily: "Lato",
              fontSize: 14,
              fontWeight: 400,
              "&::before, &::after": {
                borderColor: "var(--Neutrals-900, #6F8090)",
                borderTopWidth: "1px",
              },
            }}>
            Or
          </Divider>
          <Grid
            item
            sx={{
              width: "100%",
              height: "60px",
            }}>
            <LabelButton
              type="primary"
              variant="contained"
              text={"Continue with email"}
              function={handleRegisterWithEmail}
              disableButtonStyle={{
                border: "none",
                background: "var(--Primary-500, #16124C)",
                color: "var(--Neutrals-100, #FFF)",
                opacity: 0.25,
              }}
            />
          </Grid>
        </>
      )}
    </>
  );
}
